import { createFileRoute } from '@tanstack/react-router';

import { Template } from '@/features/templates';

export const Route = createFileRoute('/templates/$templateId')({
  component: Template,
});
